import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Hero from './Hero';
import Position from './Position';
import HousePhoto from './HousePhoto';
import JacuzziSuite from './JacuzziSuite';
import Room from './Room';
import Breakfast from './Breakfast';
import VideoSection from './VideoSection';
import Reviews from './Reviews';
import Services from './Services';
import Contact from './Contact';

function Main() {
    const { isEnLang } = useLanguage();

    useEffect(() => {
        document.title = isEnLang
            ? 'B&B Alma Suite Anzio – Jacuzzi Suite, Rooms & Breakfast | Nettuno'
            : 'B&B Alma Suite Anzio – Suite Jacuzzi, Camere e Colazione | Nettuno';
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute('content', isEnLang
            ? 'B&B Alma Suite between Anzio and Nettuno: exclusive Jacuzzi Suite brand new 2026, modern rooms, homemade breakfast included, reserved parking. Book now.'
            : 'B&B Alma Suite tra Anzio e Nettuno: Suite Jacuzzi esclusiva nuova costruzione 2026, camere moderne, colazione artigianale inclusa, parcheggio riservato. Prenota ora.'
        );
    }, [isEnLang]);

    return (
        <main>
            <Hero />
            <Position />
            <HousePhoto />
            <JacuzziSuite />
            <Room />
            <Breakfast />
            <VideoSection />
            <Reviews />
            <Services />
            <Contact />
        </main>
    );
}

export default Main;
